/* globals BS */

import * as util from './util'

export default {
	name: 'DailySchedule',
	props: {
		day: {
			type: Object,
			required: true
		},
		appUrl: {
			type: String
		},
		showOrders: {
			type: Boolean,
			default: false
		},
		matometeEditable: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			isToggling: false,
			eventType: null, // 先に発生したイベントのみ受け付ける
			togglingState: false,
			prevTarget: null
		}
	},
	methods: {
		toggleStart: function (eventType, event, div) {
			if (!this.matometeEditable) {
				return
			}
			event.preventDefault()
			if (this.isToggling) {
				return
			}
			this.isToggling = true
			this.eventType = eventType
			this.togglingState = !div.isActive
			this.prevTarget = null
			div.isActive = !div.isActive
			this.$emit('scheduleChange')
		},
		toggleMove: function (eventType, event) {
			if (!this.isToggling || this.eventType !== eventType) {
				return
			}
			event.preventDefault()

			const targetE = BS.event.touchmoveTarget(event)
			if (!targetE) {
				this.isToggling = false
				return
			}
			const divE = BS.DOM.closest('.ds-col-body', targetE)
			if (!divE || this.prevTarget === divE) {
				return
			}
			this.prevTarget = divE
			this.day.divs[divE.getAttribute('data-index')].isActive = this.togglingState
		},
		toggleStop: function () {
			this.isToggling = false
		},
		orderStatusClass (order) {
			return 'ds-order-status-' + order.status
		},
		orderLengthClass (order) {
			const from = util.timeStringToHours(order.from)
			const to = util.timeStringToHours(order.to)
			const hours = to - from
			const classes = ['ds-order-len-' + Math.floor(hours).toString() + ((hours % 1) >= 0.5 ? 'h' : '')]
			if ((from % 1) >= 0.5) {
				classes.push('ds-order-offset-h')
			}
			return classes.join(' ')
		},
		orderLink (orderId) {
			if (!this.appUrl) return null
			return this.appUrl + '/maman/order/' + orderId + '/'
		},
		hourEquals (a, b) {
			// 09:00 vs 09:30 => true
			return parseInt(a, 10) === parseInt(b, 10)
		}
	},
	template: `
	<div class="daily-schedule"
		@mousemove="toggleMove('mouse', $event)"
		@touchmove="toggleMove('touch', $event)"
		@mouseup="toggleStop"
		@mouseleave="toggleStop"
		@touchend="toggleStop"
	>
		<div class="ds-row ds-row-axis">
			<span
				v-for="div in day.divs"
				:key="div.index"
				class="ds-col"
			>
				{{ div.fromHour }}
			</span>
		</div>
		<div
			class="ds-row ds-row-body"
			:class="{ past: day.past, 'cannot-reserve': !day.canReserve }"
		>
			<span
				v-for="div in day.divs" :key="div.index"
				:data-index="div.index"
				class="ds-col ds-col-body"
				:class="{ 'can-work': div.isActive, 'has-order': div.hasOrder, selectable: matometeEditable }"
				@mousedown="toggleStart('mouse', $event, div)"
				@touchstart="toggleStart('touch', $event, div)"
			>
				<template
					v-if="!matometeEditable && hourEquals(order.from, div.from)"
					v-for="order in day.orders"
				>
					<template v-if="showOrders">
						<a
							:href="orderLink(order.id)"
							class="ds-order"
							:class="orderStatusClass(order) + ' ' + orderLengthClass(order)"
						>
							{{order.nick}}
						</a>
					</template>
					<template v-else>
						<span
							class="ds-order ds-order-unavailable"
							:class="orderLengthClass(order)"
						>
							依頼あり
						</span>
					</template>
				</template>
			</span>
		</div>
	</div>
	`
}
